export const radius = {
  xxxxs: "0.5rem",
  xxs: "1.5rem",
  s: "6.875rem",
};
